import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

interface RestorePromptProps {
  showRestorePrompt: boolean;
  onStartNewChat: () => void;
  onRestoreChat: () => void;
}

export function RestorePrompt({ 
  showRestorePrompt, 
  onStartNewChat, 
  onRestoreChat 
}: RestorePromptProps) {
  return (
    <div 
      className="fixed inset-0 bg-background/80 backdrop-blur-sm z-50 flex items-center justify-center"
      style={{ display: showRestorePrompt ? 'flex' : 'none' }}
    >
      <AlertDialog open={showRestorePrompt}>
        <AlertDialogContent className="z-[60]">
          <AlertDialogHeader>
            <AlertDialogTitle>Gjenopprette forrige chat?</AlertDialogTitle>
            <AlertDialogDescription>
              Det ser ut som du har en tidligere samtale lagret. Vil du fortsette den eller starte en ny chat?
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel onClick={onStartNewChat}>
              Start ny chat
            </AlertDialogCancel>
            <AlertDialogAction onClick={onRestoreChat}>
              Fortsett forrige chat
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </div>
  );
}